<template>
  <div class="copywrite">
    <span class="body--xsmall">©2024 BetaScore. All Rights Reserved.</span>
    <div style="width: fit-content;">
      <button
        class="button-tertiary--small"
        @click="open"
      >
        Beta Financial Services
        <i class="bi bi-arrow-up-right" />
      </button>
    </div>
  </div>
</template>

<script lang="js">
export default {
    name: 'CopyWrite',
    methods: {
        open() {
            window.open('https://www.betafinancialservices.com', '_blank');
        }
    }
}
</script>

<style lang="scss">
.copywrite {
    @include inline-space($space-medium);
    justify-content: center;
    flex-wrap: wrap;

    span {
        @include inline-space($space-medium);
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    button {
        color: $color-black;

        .bi {
            font-size: $icon-xsmall;
        }
    }
}
</style>